import {
  ConvencaoJurosFixo,
  IndexadorRemuneracao,
  DefasagemFixingBase,
  TipoProRata,
  CorrecaoJurosFixos,
  TratamentoValor,
  IndexadorJurosFlutuante,
  PeriodicidadeCorrecao,
  TipoProjecao,
  TratamentoFator,
  RegistroStatus,
  UploadDocumentType,
  NegociacaoSecundaria,
  TipoSerie,
  DepositariaEmissao,
  PercentualAmortizacao,
  ParticipanteUploadDocumentType,
  TipoRepresentanteLegal,
  TipoCargo,
  TipoAcessoParticipante,
  FuncaoParticipante,
  InvestidorDocumentType,
  OperacaoTipo,
  PagamentoTipo,
  PagamentoStatus,
  CompraVendaStatus,
  OperacaoCommonStatus,
  BloqueioTipo,
  MotivoTransferencia,
  TransferenciaTipo,
  ConstricaoTipo,
  EventoExtraordinarioTipo,
  TipoInteroperabilidade,
  EmissaoStatus,
  TipoInvestidor,
  FuncaoInternaParticipante,
  ConciliacaoStatus,
  Perfil,
  TipoAcessoParticipanteHistorico,
  FuncaoParticipanteHistorico,
  ParticipanteDocumentoTipoHistorico,
  RepresentanteLegalTipoHistorico,
  CargoTipoHistorico,
  DocumentTypeHistorico,
  TipoSerieHistorico,
  NegociacaoSecundariaHistorico,
  StatusTransferenciaCustodia,
  StatusInteroperabilidade,
  DebentureUploadDocumentType,
  NotaComercialUploadDocumentType,
  InstrumentoFinanceiro,
  TipoLiquidacao,
  OfertaPrimariaStatus,
  UploadDocumentCredenciado,
  AditamentoStatus,
  TipoPagamento,
  ConvencaoCalendarioPagamento,
  PeriodicidadeFluxoPagamento,
  TipoDocumentoS3,
  GrupoAcesso,
  GarantiaTipoEnum,
  GarantiaSubTipoEnum,
  TipoCertidao,
  LaqusUserUploadDocumentType,
  InicioRentabilidadeEnum,
  ContraparteRecebedoraEnum,
  TipoNotificacaoEnum,
  TipoDestinatariosEnum
} from './genericTypes';

export const convencaoJurosFixosDescriptions: { [key: string]: string } = {
  [ConvencaoJurosFixo.DCP_360]: '(dcp/360)',
  [ConvencaoJurosFixo.DCP_365]: '(dcp/365)',
  [ConvencaoJurosFixo.DUP_252]: '(dup/252)',
  [ConvencaoJurosFixo._21_252eDCP_DCT]: '(21/252)^(dcp/dct)',
  [ConvencaoJurosFixo._21_252xDCP_DCT]: '(21/252) x (dcp/dct)',
  [ConvencaoJurosFixo._30_360eDCP_DCT]: '(30/360)^(dcp/dct)',
  [ConvencaoJurosFixo._30_360xDCP_DCT]: '(30/360) x (dcp/dct)',
  [ConvencaoJurosFixo.Actual30_360]: '30/360 (%aa)',
  [ConvencaoJurosFixo.Actual360]: 'DC/360 (%aa)',
  [ConvencaoJurosFixo.Actual365]: 'DC/365 (%aa)',
  [ConvencaoJurosFixo.Business252]: 'DU/252 (%aa)',
  [ConvencaoJurosFixo.Month_30]: 'DC/30 (%am)',
  [ConvencaoJurosFixo._30dc]: '30dc (%am)',
};

export const negociacaoSecundariaDescriptions: { [key: string]: string } = {
  [NegociacaoSecundaria.Profissional]: 'Investidor Profissional',
  [NegociacaoSecundaria.Qualificado]: 'Investidor Qualificado',
  [NegociacaoSecundaria.SemRestricao]: 'Sem Restrição',
};

export const tipoSerieDescriptions: { [key: string]: string } = {
  [TipoSerie.Senior]: 'Sênior',
  [TipoSerie.Subordinada]: 'Subordinada',
};

export const statusFormularioDescriptions: { [key: string]: string } = {
  [RegistroStatus.EmAnalise]: 'Em Análise',
  [RegistroStatus.Aprovado]: 'Aprovado',
  [RegistroStatus.Reprovado]: 'Reprovado',
  [RegistroStatus.AguardandoCorrecao]: 'Reprovado - Aguardando Correção',
  [RegistroStatus.Excluido]: 'Excluido',
  [RegistroStatus.AguardandoAprovacaoEdicao]: 'Aguardando Aprovação Edição',
  [RegistroStatus.AguardandoAprovacaoAditamento]: 'Aguardando Aprovação Aditamento',
};

export const statusFormularioDescriptionsAditamento: { [key: string]: string } = {
  [AditamentoStatus.EmAnalise]: 'Em Análise',
  [AditamentoStatus.Aprovado]: 'Aprovado',
  [AditamentoStatus.Reprovado]: 'Reprovado',
};

export const indexadorRemuneracaoDescriptions: { [key: string]: string } = {
  [IndexadorRemuneracao.Prefixado]: 'Prefixado',
  [IndexadorRemuneracao.CDI]: 'CDI',
  [IndexadorRemuneracao.Selic]: 'Selic',
  [IndexadorRemuneracao.IGPM]: 'IGP-M',
  [IndexadorRemuneracao.IPCA]: 'IPCA',
  [IndexadorRemuneracao.TR]: 'TR',
};

export const inicioRentabilidadeDescriptions: { [key: string]: string } = {
  [InicioRentabilidadeEnum.DATA_DE_INTEGRALIZACAO]: 'Data de Integralização',
  [InicioRentabilidadeEnum.DATA_DE_EMISSAO]: 'Data de Emissão'
};

export const contraparteRecebedoraDescriptions: { [key: string]: string } = {
  [ContraparteRecebedoraEnum.BANCO_LIQUIDANTE_EMISSOR]: 'Banco Liquidante do Emissor',
  [ContraparteRecebedoraEnum.COORDENADOR_LIDER]: 'Coordenador Líder',
};

export const defasagemFixingBaseDescriptions: { [key: string]: string } = {
  [DefasagemFixingBase.Customizado]: 'Customizado',
};

export const tipoProRataDescriptions: { [key: string]: string } = {
  [TipoProRata.Corrido]: 'Corrido',
  [TipoProRata.Util]: 'Útil',
};

export const correcaoDescriptions: { [key: string]: string } = {
  [CorrecaoJurosFixos.Principal]: 'Sobre o Saldo do Principal',
  [CorrecaoJurosFixos.Parcela]: 'Sobre a Parcela do Principal',
};

export const tratamentoDescriptions: { [key: string]: string } = {
  [TratamentoValor.Truncar]: 'Truncar',
  [TratamentoValor.Arredondar]: 'Arredondar',
  [TratamentoFator.SemTratamento]: 'Sem Tratamento',
};

export const indexadorJurosFlutuantesDescriptions: { [key: string]: string } = {
  [IndexadorJurosFlutuante.CDI]: 'CDI',
  [IndexadorJurosFlutuante.SelicOver]: 'Selic Over',
  [IndexadorJurosFlutuante.MetaSelic]: 'Meta Selic',
};

export const tipoProjecaoDescriptions: { [key: string]: string } = {
  [TipoProjecao.Anbima]: 'Anbima',
  [TipoProjecao.RepeteUltimo]: 'Repete o último',
};

export const periodicidadeCorrecaoDescriptions: { [key: string]: string } = {
  [PeriodicidadeCorrecao.Anual]: 'Anual',
  [PeriodicidadeCorrecao.Mensal]: 'Mensal',
  [PeriodicidadeCorrecao.Diario]: 'Diário',
};

export const documentShortDescriptions: { [key: string]: string } = {
  [UploadDocumentType.TermoSecuritizacao]: 'Termo de Securitização',
  [UploadDocumentType.DeclaracaoInstituicaoCustodiante]: 'Declaração da Instituição Custodiante',
  [UploadDocumentType.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição',
  [UploadDocumentType.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário',
  [UploadDocumentType.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública',
  [UploadDocumentType.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo)',
  [UploadDocumentType.TermoConstitutivo]: 'Termo Constitutivo',
  [UploadDocumentType.CartulaEmissao]: 'Cártula de Emissão',
  [UploadDocumentType.RegulamentoFundo]: 'Regulamento do Fundo',
  [UploadDocumentCredenciado.Credenciado]: 'Comprovantes credenciado',
  [LaqusUserUploadDocumentType.BoletimSubscricao]: 'Boletins de Subscrição'
};

export const documentLongDescriptions: { [key: string]: string } = {
  [UploadDocumentType.TermoSecuritizacao]: 'Termo de Securitização',
  [UploadDocumentType.DeclaracaoInstituicaoCustodiante]: 'Declaração de Custodia',
  [UploadDocumentType.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição',
  [UploadDocumentType.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário - ICVM 583',
  [UploadDocumentType.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública expedido pela CVM',
  [UploadDocumentType.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo)',
  [UploadDocumentType.TermoConstitutivo]: 'Termo Constitutivo',
  [UploadDocumentType.CartulaEmissao]: 'Cártula de Emissão',
  [UploadDocumentType.RegulamentoFundo]: 'Regulamento do Fundo',
  [UploadDocumentCredenciado.Credenciado]: 'Comprovantes credenciado',
  [LaqusUserUploadDocumentType.BoletimSubscricao]: 'Boletins de Subscrição'
};

export const notaComercialDocumentShortDescriptions: { [key: string]: string } = {
  [NotaComercialUploadDocumentType.CartulaEmissao]: 'Cártula de Emissão',
  [NotaComercialUploadDocumentType.DeclaracaoInstituicaoCustodiante]: 'Declaração da Instituição Custodiante',
  [NotaComercialUploadDocumentType.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição',
  [NotaComercialUploadDocumentType.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário',
  [NotaComercialUploadDocumentType.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública',
  [NotaComercialUploadDocumentType.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo)',
  [LaqusUserUploadDocumentType.BoletimSubscricao]: 'Boletins de Subscrição'
};

export const notaComercialDocumentLongDescriptions: { [key: string]: string } = {
  [NotaComercialUploadDocumentType.CartulaEmissao]: 'Cártula de Emissão',
  [NotaComercialUploadDocumentType.DeclaracaoInstituicaoCustodiante]: 'Declaração de Custodia',
  [NotaComercialUploadDocumentType.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição',
  [NotaComercialUploadDocumentType.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário - ICVM 583',
  [NotaComercialUploadDocumentType.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública expedido pela CVM',
  [NotaComercialUploadDocumentType.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo)',
  [LaqusUserUploadDocumentType.BoletimSubscricao]: 'Boletins de Subscrição'
};

export const debentureDocumentShortDescriptions: { [key: string]: string } = {
  [DebentureUploadDocumentType.EscrituraEmissao]: 'Escritura de Emissão',
  [DebentureUploadDocumentType.DeclaracaoInstituicaoCustodiante]: 'Declaração da Instituição Custodiante',
  [DebentureUploadDocumentType.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição',
  [DebentureUploadDocumentType.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário',
  [DebentureUploadDocumentType.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública',
  [DebentureUploadDocumentType.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo)',
  [LaqusUserUploadDocumentType.BoletimSubscricao]: 'Boletins de Subscrição'
};

export const debentureDoumentLongDescriptions: { [key: string]: string } = {
  [DebentureUploadDocumentType.EscrituraEmissao]: 'Escritura de Emissão',
  [DebentureUploadDocumentType.DeclaracaoInstituicaoCustodiante]: 'Declaração de Custodia',
  [DebentureUploadDocumentType.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição',
  [DebentureUploadDocumentType.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário - ICVM 583',
  [DebentureUploadDocumentType.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública expedido pela CVM',
  [DebentureUploadDocumentType.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo)',
  [LaqusUserUploadDocumentType.BoletimSubscricao]: 'Boletins de Subscrição'
};

export const depositariaEmissaoDescriptions: { [key: string]: string } = {
  [DepositariaEmissao.Laqus]: 'Laqus',
  [DepositariaEmissao.B3]: 'B3',
  [DepositariaEmissao.Outros]: 'Outros',
};

export const percentualAmortizacaoDescriptions: { [key: string]: string } = {
  [PercentualAmortizacao.Principal]: 'Principal',
  [PercentualAmortizacao.SaldoDevedor]: 'Saldo Devedor',
};

export const participanteDocumentShortDescriptions: { [key: string]: string } = {
  [ParticipanteUploadDocumentType.ContratoSocial]: 'Contrato/Estatuto Social em vigor',
  [ParticipanteUploadDocumentType.ComprovanteEleicao]: 'Comprovante de eleição dos diretores e/ou administradores',
  [ParticipanteUploadDocumentType.DemonstracaoFinanceira]: `DF's auditadas dos últimos 3 exercícios`,
  [ParticipanteUploadDocumentType.TermoAdesaoParticipante]: 'Termo de Adesão de Participante',
  [ParticipanteUploadDocumentType.ComprovantePoderSignatario]:
    'Comprovação de poderes dos signatários do Termo de Adesão',
  [ParticipanteUploadDocumentType.AtoDeclaratorioCVM]:
    'Comprovação junto à CVM de habilitação à exercer tais funções como Participante',
  [ParticipanteUploadDocumentType.Procuracao]: 'Procuração',
  [ParticipanteUploadDocumentType.Identidade]: 'Documento de identidade dos Representantes Legais',
  [ParticipanteUploadDocumentType.Outros]: 'Outros',
};

export const participanteDocumentLongDescriptions: { [key: string]: string } = {
  [ParticipanteUploadDocumentType.ContratoSocial]:
    'Contrato Social/Estatuto Social atualmente em vigor, registrado na Junta Comercial',
  [ParticipanteUploadDocumentType.ComprovanteEleicao]: `Cópia simples da comprovação de eleição dos diretores da instituição e/ou administradores (Ata da Assembleia ou Alteração Contratual) registrada na Junta Comercial e homologada pelo BCB`,
  [ParticipanteUploadDocumentType.DemonstracaoFinanceira]: `Demonstração financeira dos últimos 3 (três) exercícios, com parecer de auditor independente, para avaliação dos indicadores econômicos e financeiros`,
  [ParticipanteUploadDocumentType.TermoAdesaoParticipante]:
    'Termo de Adesão de Participante devidamente assinado por representantes legais',
  [ParticipanteUploadDocumentType.ComprovantePoderSignatario]:
    'Documentos societários que comprovem os poderes dos signatários que assinaram o Termo de Adesão de Participante',
  [ParticipanteUploadDocumentType.AtoDeclaratorioCVM]:
    'Comprovante de que o interessado está devidamente habilitado pela CVM a exercer a respectiva função de Participante (Ato declaratório da CVM)',
  [ParticipanteUploadDocumentType.Procuracao]: 'Procuração',
  [ParticipanteUploadDocumentType.Identidade]:
    'Documento de identidade dos administradores e procurador, este último se houver',
  [ParticipanteUploadDocumentType.Outros]: 'Outros documentos e informações que julgar pertinente',
};

export const tipoRepresentanteLegalDescriptions: { [key: string]: string } = {
  [TipoRepresentanteLegal.Administrador]: 'Administrador',
  [TipoRepresentanteLegal.Controlador]: 'Controlador',
  [TipoRepresentanteLegal.Procurador]: 'Procurador',
  [TipoRepresentanteLegal.RepresentanteLegal]: 'Representante Legal',
};

export const tipoCargoDescriptions: { [key: string]: string } = {
  [TipoCargo.Analista]: 'Analista',
  [TipoCargo.C_Level]: 'C-Level',
  [TipoCargo.Coordenador]: 'Coordenador',
  [TipoCargo.Gerente]: 'Gerente',
  [TipoCargo.Juridico]: 'Juridico',
  [TipoCargo.SegurancaInformacao]: 'Segurança da Informação',
  [TipoCargo.RepresentanteLegal]: 'Representante Legal',
};

export const tipoAcessoParticipanteDescriptions: { [key: string]: string } = {
  [TipoAcessoParticipante.Participante]: 'Participante',
  [TipoAcessoParticipante.Depositaria]: 'Depositária',
};

export const funcaoParticipanteDescriptions: { [key: string]: string } = {
  [FuncaoParticipante.Emissor]: 'Emissor',
  [FuncaoParticipante.Custodiante]: 'Custodiante',
  [FuncaoParticipante.Escriturador]: 'Escriturador',
  [FuncaoInternaParticipante.Depositaria]: 'Depositária',
  [FuncaoParticipante.Credenciado]: 'Credenciado',
  [FuncaoParticipante.Coordenador]: 'Coordenador',
  [FuncaoParticipante.AgenteFiduciario]: 'Agente Fiduciário',
  [FuncaoParticipante.AdministradorFiduciario]: 'Administrador Fiduciário',
};

export const investidorDocumentTypeDescriptions: { [key: string]: string } = {
  [InvestidorDocumentType.IdentidadeInvestidor]: 'Identidade Investidor (RG, CPF, RNE, Cartão CNPJ)',
  [InvestidorDocumentType.ContratoSocial]: 'Estatuto Social, Contrato Social ou documento equivalente',
  [InvestidorDocumentType.ComprovanteEndereco]: 'Comprovante de Endereço',
  [InvestidorDocumentType.ComprovanteRenda]: 'Comprovante de Renda (Holerite, IRPF, DFs)',
  [InvestidorDocumentType.IdentidadeRepresentanteLegalProcurador]: 'Identidade Representante Legal/Procurador',
  [InvestidorDocumentType.Procuracao]: 'Procuração',
};

export const investidorPfDocumentTypeDescriptions: { [key: string]: string } = {
  [InvestidorDocumentType.IdentidadeInvestidor]: 'Documento de Identidade (RG, CPF, RNE)',
  [InvestidorDocumentType.ContratoSocial]: 'Estatuto Social, Contrato Social ou documento equivalente',
  [InvestidorDocumentType.ComprovanteEndereco]: 'Comprovante de Endereço',
  [InvestidorDocumentType.ComprovanteRenda]: 'Comprovante de Renda (Holerite, IRPF)',
  [InvestidorDocumentType.IdentidadeRepresentanteLegalProcurador]: 'Identidade Representante Legal/Procurador',
  [InvestidorDocumentType.Procuracao]: 'Procuração',
};

export const investidorPjDocumentTypeDescriptions: { [key: string]: string } = {
  [InvestidorDocumentType.IdentidadeInvestidor]: 'Cartão CNPJ',
  [InvestidorDocumentType.ContratoSocial]: 'Estatuto Social, Contrato Social ou documento equivalente',
  [InvestidorDocumentType.ComprovanteEndereco]: 'Comprovante de Endereço',
  [InvestidorDocumentType.ComprovanteRenda]: 'Demonstrativo Financeiro',
  [InvestidorDocumentType.IdentidadeRepresentanteLegalProcurador]: 'Identidade Representante Legal/Procurador',
  [InvestidorDocumentType.Procuracao]: 'Procuração',
};

export const operacaoTipoDescriptions: { [key: string]: string } = {
  [OperacaoTipo.OfertaPrimaria]: 'Oferta Primária',
  [OperacaoTipo.CompraVenda]: 'Compra e Venda',
  [OperacaoTipo.Compra]: 'Compra',
  [OperacaoTipo.Venda]: 'Venda',
  [OperacaoTipo.CompraVendaCompromissada]: 'Operação Compromissada',
  [OperacaoTipo.CompraVendaCompromissadaRetorno]: 'Retorno de Compromissada',
  [OperacaoTipo.Transferencia]: 'Transferência',
  [OperacaoTipo.TransferenciaTitularidade]: 'Transferência de Titularidade',
  [OperacaoTipo.TransferenciaCustodia]: 'Transferência de Custódia',
  [OperacaoTipo.TransferenciaUnificada]: 'Transferência',
  [OperacaoTipo.TransferenciaInterop]: 'Interoperabilidade',
  [OperacaoTipo.SaidaInteroperabilidade]: 'Saída por Interoperabilidade',
  [OperacaoTipo.CancelamentoQuantidades]: 'Cancelamento de Quantidades',
};

export const pagamentoTipoDescriptions: { [key: string]: string } = {
  [PagamentoTipo.Amortizacao]: 'Amortização',
  [PagamentoTipo.Juros]: 'Juros',
  [PagamentoTipo.Mora]: 'Mora',
  [PagamentoTipo.Multa]: 'Multa',
  [PagamentoTipo.Premio]: 'Prêmio',
};

export const pagamentoStatusDescriptions: { [key: string]: string } = {
  [PagamentoStatus.Previsto]: 'Previsto',
  [PagamentoStatus.PendenteAprovacao]: 'Liquidação pendente de Aprovação',
  [PagamentoStatus.PendenteAprovacaoAgenteFiduciario]: 'Pendente de aprovação A.F.',
  [PagamentoStatus.Concluida]: 'Concluída',
  [PagamentoStatus.AguardandoLiquidacao]: 'Aguardando Liquidação',
  [PagamentoStatus.Reprovada]: 'Reprovada',
  [PagamentoStatus.ReprovadoAgenteFiduciario]: 'Reprovado pelo A.F.',
  [PagamentoStatus.Cancelada]: 'Cancelada',
  [PagamentoStatus.AguardandoComprovante]: 'Aguardando Comprovante',
  [PagamentoStatus.ParcialmenteConcluida]: 'Parcialmente Concluída',
};

export const eventoExtraordinarioTipoDescriptions = {
  [EventoExtraordinarioTipo.Amortizacao]: 'Amortização Extraordinária',
  [EventoExtraordinarioTipo.ResgateAntecipadoTotal]: 'Resgate Antecipado Total',
};

export const eventoFinanceiroDescriptions: { [key: string]: string } = {
  ...pagamentoTipoDescriptions,
  ...eventoExtraordinarioTipoDescriptions,
};

export const operacaoCommonStatusDescriptions = {
  [OperacaoCommonStatus.EmAnalise]: 'Em análise',
  [OperacaoCommonStatus.Concluida]: 'Concluída',
  [OperacaoCommonStatus.Reprovada]: 'Reprovada',
};

export const compraVendaStatus: { [key: string]: string } = {
  [CompraVendaStatus.Cancelada]: 'Cancelada',
  [CompraVendaStatus.AguardandoLiquidacao]: 'Aguardando Liquidação',
  [CompraVendaStatus.AguardandoAprovacaoADMFiduciario]: 'Aguardando Aprovação ADM Fiduciário',
  [CompraVendaStatus.AceiteOrigemRealizado]: 'Aceite Origem Realizado',
  [CompraVendaStatus.AceiteDestinoRealizado]: 'Aceite Destino Realizado',
  [CompraVendaStatus.LiquidacaoEmProcessamento]: 'Liquidação em Processamento',
};

export const ofertaPrimariaStatus: { [key: string]: string } = {
  [OfertaPrimariaStatus.AguardandoConfirmacao]: 'Aguardando Confirmação',
  [OfertaPrimariaStatus.Agendado]: 'Agendado'
};

export const operacaoStatusDescriptions: { [key: string]: string } = {
  ...operacaoCommonStatusDescriptions,
  ...compraVendaStatus,
  ...ofertaPrimariaStatus,
};

export const interoperabilidadeStatusDescriptions: { [key: string]: string } = {
  [StatusInteroperabilidade.Aprovado]: 'Concluída',
  [StatusInteroperabilidade.Reprovado]: 'Recusada',
  [StatusInteroperabilidade.Pendente]: 'Aguardando Confirmação',
};

export const bloqueioTipoDescriptions: { [key: string]: string } = {
  [BloqueioTipo.Garantia]: 'Garantia',
  [BloqueioTipo.Constricao]: 'Constrição',
};

export const motivoTransferenciaDescriptions: { [key: string]: string } = {
  [MotivoTransferencia.Doacao]: 'Doação',
  [MotivoTransferencia.Heranca]: 'Herança',
  [MotivoTransferencia.Pagamento]: 'Dação em Pagamento',
  [MotivoTransferencia.Societario]: 'Societário',
  [MotivoTransferencia.ExecucaoConstricaoGarantia]: 'Execução por Constrição/Garantia',
  [MotivoTransferencia.Outro]: 'Outro',
};

export const transferenciaTipoDescriptions: { [key: string]: string } = {
  [TransferenciaTipo.Custodia]: 'Custódia',
  [TransferenciaTipo.Titularidade]: 'Titularidade',
};

export const transferenciaStatusDescriptions: Record<string, string> = {
  PENDENTE: 'Em Análise',
  CONCLUIDO: 'Concluído',
  REPROVADO: 'Reprovado',
};

export const constricaoTipoDescriptions = {
  [ConstricaoTipo.Judicial]: 'Judicial',
  [ConstricaoTipo.Administrativa]: 'Administrativa',
};

export const tipoInteroperabilidadeDescriptions: { [key: string]: string } = {
  [TipoInteroperabilidade.Entrada]: 'Entrada',
  [TipoInteroperabilidade.Saida]: 'Saída',
};
export const emissaoStatusDescriptions = {
  [EmissaoStatus.AguardandoLiquidacao]: 'Aguardando Liquidação',
  [EmissaoStatus.Emitido]: 'Emitido',
  [EmissaoStatus.ParcialmenteEmitido]: 'Parcialmente Emitido',
  [EmissaoStatus.NaoEmitido]: 'Não emitido',
};

export const registroStatusDescriptions = {
  [RegistroStatus.AguardandoAprovacaoEdicao]: 'Aguardando Aprovação Edição',
  [RegistroStatus.AguardandoAprovacaoAditamento]: 'Aguardando Aprovação Aditamento',
};

export const tipoInvestidorDescriptions = {
  [TipoInvestidor.Profissional]: 'Profissional',
  [TipoInvestidor.Qualificado]: 'Qualificado',
  [TipoInvestidor.Nenhum]: 'Nenhum',
  [TipoInvestidor.Fundo]: 'Fundo',
};

export const conciliacaoStatusDescriptions = {
  [ConciliacaoStatus.AguardandoConciliacao]: 'Aguardando Conciliação',
  [ConciliacaoStatus.AguardandoDownload]: 'Aguardando Download',
  [ConciliacaoStatus.Conciliado]: 'Conciliado',
};

export const perfilDescriptions = {
  [Perfil.Master]: 'Master',                               
  [Perfil.Escrita]: 'Escrita',
  [Perfil.Leitura]: 'Leitura',
};

export const grupoAcessoDescriptions = {
  [GrupoAcesso.Comum]: 'Participante Comum',
  [GrupoAcesso.Operacoes]: 'Operações',
  [GrupoAcesso.OperacoesLeitura]: 'Operações Leitura',
  [GrupoAcesso.ControlesInternos]: 'Controles Internos',
  [GrupoAcesso.CadastroOperacoes]: 'Cadastro de Operações',
  [GrupoAcesso.CadastroLeitura]: 'Cadastro Leitura',
  [GrupoAcesso.GestaoAcessos]: 'Gestão de Acessos',
};

export const tipoNotificacaoDescriptions = {
  [TipoNotificacaoEnum.EventoPrevistoPagamento]: 'Evento Previsto de Pagamento',
};

export const tipoDestinatariosDescriptions = {
  [TipoDestinatariosEnum.TodosDaFuncao]: 'Todos da Função',
  [TipoDestinatariosEnum.UsuariosSelecionados]: 'Usuários Selecionados',
  [TipoDestinatariosEnum.EmailsEspecificos]: 'E-mails Específicos',
};

export const tipoAcessoParticipanteHistoricoDescriptions = {
  [TipoAcessoParticipanteHistorico.Participante]: 'Participante',
  [TipoAcessoParticipanteHistorico.Credenciado]: 'Credenciado',
  [TipoAcessoParticipanteHistorico.Depositaria]: 'Depositária',
  [TipoAcessoParticipanteHistorico.Investidor]: 'Investidor',
};

export const funcaoParticipanteHistoricoDescriptions = {
  [FuncaoParticipanteHistorico.Depositaria]: 'Depositária',
  [FuncaoParticipanteHistorico.Emissor]: 'Emissor',
  [FuncaoParticipanteHistorico.Escriturador]: 'Escriturador',
  [FuncaoParticipanteHistorico.Custodiante]: 'Custodiante',
  [FuncaoParticipanteHistorico.BancoLiquidante]: 'Banco Liquidante',
  [FuncaoParticipanteHistorico.AgenteFiduciario]: 'Agente Fiduciário',
};

export const participanteHistoricoDocumentDescriptions: { [key: string]: string } = {
  [ParticipanteDocumentoTipoHistorico.CartaoAssinaturas]: 'Cartão de Assinaturas',
  [ParticipanteDocumentoTipoHistorico.ContratoSocial]:
    'Contrato Social/Estatuto Social atualmente em vigor, registrado na Junta Comercial',
  [ParticipanteDocumentoTipoHistorico.ComprovanteEleicao]: `Cópia simples da comprovação de eleição dos diretores da instituição e/ou administradores (Ata da Assembleia ou Alteração Contratual) registrada na Junta Comercial e homologada pelo BCB`,
  [ParticipanteDocumentoTipoHistorico.DemonstracaoFinanceira]: `Demonstração financeira dos últimos 3 (três) exercícios, com parecer de auditor independente, para avaliação dos indicadores econômicos e financeiros`,
  [ParticipanteDocumentoTipoHistorico.TermoAdesaoParticipante]:
    'Termo de Adesão de Participante devidamente assinado por representantes legais',
  [ParticipanteDocumentoTipoHistorico.ComprovantePoderSignatario]:
    'Documentos societários que comprovem os poderes dos signatários que assinaram o Termo de Adesão de Participante',
  [ParticipanteDocumentoTipoHistorico.AtoDeclaratorioCvm]:
    'Comprovante de que o interessado está devidamente habilitado pela CVM a exercer a respectiva função de Participante (Ato declaratório da CVM)',
  [ParticipanteDocumentoTipoHistorico.Procuracao]: 'Procuração',
  [ParticipanteDocumentoTipoHistorico.Identidade]:
    'Documento de identidade dos administradores e procurador, este último se houver',
  [ParticipanteDocumentoTipoHistorico.Outros]: 'Outros documentos e informações que julgar pertinente',
};

export const tipoRepresentanteLegalHistoricoDescriptions: { [key: string]: string } = {
  [RepresentanteLegalTipoHistorico.Administrador]: 'Administrador',
  [RepresentanteLegalTipoHistorico.Controlador]: 'Controlador',
  [RepresentanteLegalTipoHistorico.Procurador]: 'Procurador',
  [RepresentanteLegalTipoHistorico.RepresentanteLegal]: 'Representante Legal',
};

export const tipoCargoHistoricoDescriptions: { [key: string]: string } = {
  [CargoTipoHistorico.Analista]: 'Analista',
  [CargoTipoHistorico.C_Level]: 'C-Level',
  [CargoTipoHistorico.Coordenador]: 'Coordenador',
  [CargoTipoHistorico.Gerente]: 'Gerente',
  [CargoTipoHistorico.Juridico]: 'Juridico',
  [CargoTipoHistorico.SegurancaInformacao]: 'Segurança da Informação',
  [CargoTipoHistorico.RepresentanteLegal]: 'Representante Legal',
};

export const documentTypeHistoricoDescriptions: { [key: string]: string } = {
  [DocumentTypeHistorico.TermoSecuritizacao]: 'Termo de Securitização (Documentos)',
  [DocumentTypeHistorico.DeclaracaoInstituicaoCustodiante]: 'Declaração da Instituição Custodiante (Documentos)',
  [DocumentTypeHistorico.ComunicadoInicioDistribuicao]: 'Comunicado de início de distribuição (Documentos)',
  [DocumentTypeHistorico.DeclaracaoAgenteFiduciario]: 'Declaração Agente Fiduciário (Documentos)',
  [DocumentTypeHistorico.OficioConcessaoRegistroOfertaPublica]:
    'Cópia do Ofício de concessão de registro de oferta pública (Documentos)',
  [DocumentTypeHistorico.ProspectoPreliminarDefinitivo]: 'Prospecto (Preliminar ou Definitivo) (Documentos)',
  [DocumentTypeHistorico.AvisosOfertaPublica]: 'Avisos obrigatorios da oferta publica (Documentos)',
  [DocumentTypeHistorico.EscrituraEmissao]: 'Escritura de Emissão (Documentos)',
  [DocumentTypeHistorico.CartulaEmissão]: 'Cartula de Emissão (Documentos)',
};

export const tipoSerieHistoricoDescriptions: { [key: string]: string } = {
  [TipoSerieHistorico.Senior]: 'Sênior',
  [TipoSerieHistorico.Subordinada]: 'Subordinada',
};

export const negociacaoSecundariaHistoricoDescriptions: { [key: string]: string } = {
  [NegociacaoSecundariaHistorico.Profissional]: 'Investidor Profissional',
  [NegociacaoSecundariaHistorico.Qualificado]: 'Investidor Qualificado',
  [NegociacaoSecundariaHistorico.SemRestricao]: 'Sem Restrição',
};

export const statusTransferenciaCustodiaDescriptions: { [key: string]: string } = {
  [StatusTransferenciaCustodia.Aprovado]: 'Aprovado',
  [StatusTransferenciaCustodia.Pendente]: 'Pendente',
  [StatusTransferenciaCustodia.Reprovado]: 'Reprovado',
};

export const tipoLiquidacaoDescriptions: { [key: string]: string } = {
  [TipoLiquidacao.Direta]: 'Liquidação Direta',
  [TipoLiquidacao.Cip]: 'Liquidação Núclea',
  [TipoLiquidacao.Fs]: 'Liquidação Laqus Financial Service',
  [TipoLiquidacao.B3]: 'Liquidação B3',
  [TipoLiquidacao.Outras]: 'Outras Formas',
};

export const getParticipanteShortDescription = (campo: string) => {
  switch (campo) {
    case 'Codigo':
      return 'Código';
    case 'Ticket':
      return 'Ticket';
    case 'Suspenso':
      return 'Suspenso';
    case 'DataCriacao':
      return 'Data de Criação';
    case 'DataUltimaAlteracao':
      return 'Data da Última Alteração';
    case 'TipoAcesso':
      return 'Tipo de Acesso';
    case 'Funcoes':
      return 'Funções';
    case 'Cnpj':
      return 'Cnpj';
    case 'RazaoSocial':
      return 'Razão Social';
    case 'Cep':
      return 'CEP';
    case 'Logradouro':
      return 'Logradouro';
    case 'Complemento':
      return 'Complemento';
    case 'Bairro':
      return 'Bairro';
    case 'Cidade':
      return 'Cidade';
    case 'Uf':
      return 'Unidade da Federação';
    case 'Telefones':
      return 'Telefones';
    case 'AtividadePrincipalDesenvolvida':
      return 'Atividade Principal Desenvolvida';
    case 'FaturamentoMedioMensalUltimosDozeMeses':
      return 'Faturamento Médio Mensal';
    case 'RazaoSocialBancoLiquidante':
      return 'Razão Social do Banco Liquidante';
    case 'CnpjBancoLiquidante':
      return 'Cnpj do Banco Liquidante';
    case 'AgenciaBancoLiquidante':
      return 'Agencia do Banco Liquidante';
    case 'ContaBancoLiquidante':
      return 'Conta do Banco Liquidante';
    case 'RepresentantesLegais':
      return 'Representantes Legais';
    case 'Documentos':
      return 'Documentos';
    case 'Registro':
      return 'Registro';
    case 'Usuarios':
      return 'Usuários';
    default:
      return campo;
  }
};

export const getParticipanteLongDescription = (campo: string) => {
  switch (campo) {
    case 'Codigo':
      return 'Código';
    case 'Ticket':
      return 'Ticket';
    case 'Suspenso':
      return 'Suspenso';
    case 'DataCriacao':
      return 'Data de Criação';
    case 'DataUltimaAlteracao':
      return 'Data da Última Alteração';
    case 'TipoAcesso':
      return 'Tipo de Acesso (Informações Principais)';
    case 'Funcoes':
      return 'Funções (Informações Principais)';
    case 'Cnpj':
      return 'Cnpj Participante (Informações Principais)';
    case 'RazaoSocial':
      return 'Denominação ou razão social (Informações Principais)';
    case 'Cep':
      return 'CEP (Endereço e Contato)';
    case 'Logradouro':
      return 'Logradouro (Endereço e Contato)';
    case 'Complemento':
      return 'Complemento (Endereço e Contato)';
    case 'Bairro':
      return 'Bairro (Endereço e Contato)';
    case 'Cidade':
      return 'Cidade (Endereço e Contato)';
    case 'Uf':
      return 'Unidade da Federação (Endereço e Contato)';
    case 'Telefones':
      return 'Telefones (Endereço e Contato)';
    case 'AtividadePrincipalDesenvolvida':
      return 'Atividade Principal Desenvolvida (Informações Principais)';
    case 'FaturamentoMedioMensalUltimosDozeMeses':
      return 'Faturamento médio mensal dos últimos 12 meses (Informações Principais)';
    case 'RazaoSocialBancoLiquidante':
      return 'Razão Social do Banco Liquidante (Dados Bancários)';
    case 'CnpjBancoLiquidante':
      return 'Cnpj do banco liquidante (Dados Bancários)';
    case 'AgenciaBancoLiquidante':
      return 'Agencia do banco liquidante (Dados Bancários)';
    case 'ContaBancoLiquidante':
      return 'Conta do banco liquidante (Dados Bancários)';
    case 'RepresentantesLegais':
      return 'Representantes Legais (Representantes Legais)';
    case 'Documentos':
      return 'Documentos';
    case 'Registro':
      return 'Registro';
    case 'Usuarios':
      return 'Usuários';
    default:
      return campo;
  }
};

export const getInstrumentoShortDescription = (campo: string) => {
  switch (campo) {
    case 'Codigo':
      return 'Código';
    case 'StatusEmissao':
      return 'Status da emissão';
    case 'CodigoExterno':
      return 'Código externo';
    case 'NumeroEmissao':
      return 'Emissão';
    case 'NumeroSerie':
      return 'Série';
    case 'TipoSerie':
      return 'Tipo de série';
    case 'RegimeFiduciario':
      return 'Regime Fiduciário';
    case 'DistribuicaoPublica':
      return 'Distribuição pública';
    case 'NegociacaoSecundariaPor':
      return 'Negociação secundária por';
    case 'DepositariaEmissao':
      return 'Depositária de emissão';
    case 'UtilizacaoAnuncioInicioDistribuicao':
      return 'Utilização de anúncio de início de distribuição';
    case 'UfLocalEmissao':
      return 'UF do local de emissão';
    case 'LocalEmissao':
      return 'Município da emissão';
    case 'ClassificadoraRisco1':
      return 'Classificadora de risco 1';
    case 'Rating1':
      return 'Rating 1';
    case 'ClassificadoraRisco2':
      return 'Classificara de risco 2';
    case 'Rating2':
      return 'Rating 2';
    case 'UfLocalPagamento':
      return 'UF de pagamento';
    case 'LocalPagamento':
      return 'Local de pagamento';
    case 'NomeResponsavelPelasInformacoesDRI':
      return 'Nome do resp. pelas informações (DRI)';
    case 'EmailResponsavelPelasInformacoesDRI':
      return 'Email do resp. pelas informações (DRI)';
    case 'BancoLiquidanteEmissor':
      return 'Banco Liquidante do Emissor';
    case 'CnpjBancoLiquidanteEmissor':
      return 'Cnpj do Banco Liquidante Emissor';
    case 'CodigoBancoContaCorrenteVinculadaEmissao':
      return 'Cód Banco Vinculado à Emissão';
    case 'NumeroAgenciaContaCorrenteVinculadaEmissao':
      return 'Ag. Vinculada à Emissão';
    case 'NumeroContaCorrenteVinculadaEmissao':
      return 'Nº C/C Vinculada à Emissão';
    case 'ChaveExterna':
      return 'Chave Externa';
    case 'Isin':
      return 'Código ISIN';
    case 'DescricaoAdicional':
      return 'Descricão Adicional';
    case 'Garantia':
      return 'Garantia'
    case 'DescricaoAdicionalGarantias':
      return 'Descricão Adicional Garantias';
    case 'RazaoSocialInstituicaoCustodiante':
      return 'Razao Social da Inst. Custodiante';
    case 'CnpjInstituicaoCustodiante':
      return 'Cnpj da Inst. Custodiante';
    case 'Coobrigacao':
      return 'Coobrigação';
    case 'NaturezaAgenteFiduciario':
      return 'Natureza do Agente Fiduciário';
    case 'RazaoSocialAgenteFiduciario':
      return 'Razao Social Agente Fiduciário';
    case 'CpfCnpjAgenteFiduciario':
      return 'CPF/CNPJ do Agente Fiduciário';
    case 'TipoDistribuicaoPublica':
      return 'Tipo de Distribuição Pública';
    case 'DataEncerramentoDistribuicao':
      return 'Data de Encerramento Distribuição';
    case 'RazaoSocialCoordenadorLiderDistribuidor':
      return 'Razão Social Coordenador Líder (Distribuidor)';
    case 'CnpjCoordenadorLiderDistribuidor':
      return 'CNPJ Coordenador Líder (Distribuidor)';
    case 'RazaoSocialEscriturador':
      return 'Razão Social Escriturador';
    case 'CnpjEscriturador':
      return 'CNPJ Escriturador';
    case 'CraDocuments':
      return 'Documentos';
    default:
      return campo;
  }
};

export const getInstrumentoLongDescription = (campo: string) => {
  switch (campo) {
    case 'Codigo':
      return 'Código (Características da Emissão)';
    case 'StatusEmissao':
      return 'Status da emissão (Características da Emissão)';
    case 'CodigoExterno':
      return 'Código externo (Características da Emissão)';
    case 'NumeroEmissao':
      return 'Número da Emissão (Características da Emissão)';
    case 'NumeroSerie':
      return 'Número da Série (Características da Emissão)';
    case 'TipoSerie':
      return 'Tipo de série (Características da Emissão)';
    case 'RegimeFiduciario':
      return 'Regime Fiduciário (Características da Emissão)';
    case 'DistribuicaoPublica':
      return 'Distribuição pública (Características da Emissão)';
    case 'NegociacaoSecundariaPor':
      return 'Negociação secundária por (Características da Emissão)';
    case 'DepositariaEmissao':
      return 'Depositária de emissão (Características da Emissão)';
    case 'UtilizacaoAnuncioInicioDistribuicao':
      return 'Utilização de anúncio de início de distribuição (Características da Emissão)';
    case 'UfLocalEmissao':
      return 'UF do local de emissão (Características da Emissão)';
    case 'LocalEmissao':
      return 'Município da emissão (Características da Emissão)';
    case 'ClassificadoraRisco1':
      return 'Classificadora de risco 1 (Características da Emissão)';
    case 'Rating1':
      return 'Rating 1 (Características da Emissão)';
    case 'ClassificadoraRisco2':
      return 'Classificara de risco 2 (Características da Emissão)';
    case 'Rating2':
      return 'Rating 2 (Características da Emissão)';
    case 'UfLocalPagamento':
      return 'UF de pagamento (Características da Emissão)';
    case 'LocalPagamento':
      return 'Local de pagamento (Características da Emissão)';
    case 'NomeResponsavelPelasInformacoesDRI':
      return 'Nome do resp. pelas informações (DRI) (Características da Emissão)';
    case 'EmailResponsavelPelasInformacoesDRI':
      return 'Email do resp. pelas informações (DRI) (Características da Emissão)';
    case 'BancoLiquidanteEmissor':
      return 'Banco Liquidante do Emissor (Características da Emissão)';
    case 'CnpjBancoLiquidanteEmissor':
      return 'Cnpj do Banco Liquidante Emissor (Características da Emissão)';
    case 'CodigoBancoContaCorrenteVinculadaEmissao':
      return 'Cód Banco Vinculado à Emissão (Características da Emissão)';
    case 'NumeroAgenciaContaCorrenteVinculadaEmissao':
      return 'Ag. Vinculada à Emissão (Características da Emissão)';
    case 'NumeroContaCorrenteVinculadaEmissao':
      return 'Nº C/C Vinculada à Emissão (Características da Emissão)';
    case 'ChaveExterna':
      return 'Chave Externa (Características da Emissão)';
    case 'Isin':
      return 'Código ISIN (Características da Emissão)';
    case 'DescricaoAdicional':
      return 'Descricão Adicional (Características da Emissão)';
    case 'Garantia':
      return 'Garantia (Características da Emissão)';
    case 'DescricaoAdicionalGarantias':
      return 'Descricão Adicional Garantias (Características da Emissão)';
    case 'RazaoSocialInstituicaoCustodiante':
      return 'Razao Social da Inst. Custodiante (Informações do Lastro)';
    case 'CnpjInstituicaoCustodiante':
      return 'Cnpj da Inst. Custodiante (Informações do Lastro)';
    case 'Coobrigacao':
      return 'Coobrigação (Regime Fiduciário)';
    case 'NaturezaAgenteFiduciario':
      return 'Natureza do Agente Fiduciário (Regime Fiduciário)';
    case 'RazaoSocialAgenteFiduciario':
      return 'Razao Social Agente Fiduciário (Regime Fiduciário)';
    case 'CpfCnpjAgenteFiduciario':
      return 'CPF/CNPJ do Agente Fiduciário (Regime Fiduciário)';
    case 'TipoDistribuicaoPublica':
      return 'Tipo de Distribuição Pública (Distribuição Pública)';
    case 'DataEncerramentoDistribuicao':
      return 'Data de Encerramento Distribuição (Distribuição Pública)';
    case 'RazaoSocialCoordenadorLiderDistribuidor':
      return 'Razão Social Coordenador Líder (Distribuidor) (Distribuição Pública)';
    case 'CnpjCoordenadorLiderDistribuidor':
      return 'CNPJ Coordenador Líder (Distribuidor) (Distribuição Pública)';
    case 'RazaoSocialEscriturador':
      return 'Razão Social Escriturador (Distribuição Pública)';
    case 'CnpjEscriturador':
      return 'CNPJ Escriturador (Distribuição Pública)';
    case 'CraDocuments':
      return 'Documentos';
    default:
      return campo;
  }
};

export const getCraShortDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante';
    case 'TipoGarantia':
      return 'Tipo de Garantia';
    case 'AtivoGarantia':
      return 'Ativo da Garantia';
    case 'NomeGarantidor':
      return 'Nome do Garantidor';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor';
    case 'ValorGarantia':
      return 'Valor da Garantia';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getCraLongDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado (Características da Emissão)';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM (Características da Emissão)';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório (Informações do Lastro)';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante (Informações do Lastro)';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante (Informações do Lastro)';
    case 'TipoGarantia':
      return 'Tipo de Garantia (Informações do Lastro)';
    case 'AtivoGarantia':
      return 'Ativo da Garantia (Informações do Lastro)';
    case 'NomeGarantidor':
      return 'Nome do Garantidor (Informações do Lastro)';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor (Informações do Lastro)';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor (Informações do Lastro)';
    case 'ValorGarantia':
      return 'Valor da Garantia (Informações do Lastro)';
    default:
      return getInstrumentoLongDescription(campo);
  }
};

export const getCdcaShortDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante';
    case 'TipoGarantia':
      return 'Tipo de Garantia';
    case 'AtivoGarantia':
      return 'Ativo da Garantia';
    case 'NomeGarantidor':
      return 'Nome do Garantidor';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor';
    case 'ValorGarantia':
      return 'Valor da Garantia';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getCdcaLongDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado (Características da Emissão)';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM (Características da Emissão)';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório (Informações do Lastro)';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante (Informações do Lastro)';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante (Informações do Lastro)';
    case 'TipoGarantia':
      return 'Tipo de Garantia (Informações do Lastro)';
    case 'AtivoGarantia':
      return 'Ativo da Garantia (Informações do Lastro)';
    case 'NomeGarantidor':
      return 'Nome do Garantidor (Informações do Lastro)';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor (Informações do Lastro)';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor (Informações do Lastro)';
    case 'ValorGarantia':
      return 'Valor da Garantia (Informações do Lastro)';
    default:
      return getInstrumentoLongDescription(campo);
  }
};

export const getCotasDeFundoShortDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante';
    case 'TipoGarantia':
      return 'Tipo de Garantia';
    case 'AtivoGarantia':
      return 'Ativo da Garantia';
    case 'NomeGarantidor':
      return 'Nome do Garantidor';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor';
    case 'ValorGarantia':
      return 'Valor da Garantia';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getCotasDeFundoLongDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado (Características da Emissão)';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM (Características da Emissão)';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório (Informações do Lastro)';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante (Informações do Lastro)';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante (Informações do Lastro)';
    case 'TipoGarantia':
      return 'Tipo de Garantia (Informações do Lastro)';
    case 'AtivoGarantia':
      return 'Ativo da Garantia (Informações do Lastro)';
    case 'NomeGarantidor':
      return 'Nome do Garantidor (Informações do Lastro)';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor (Informações do Lastro)';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor (Informações do Lastro)';
    case 'ValorGarantia':
      return 'Valor da Garantia (Informações do Lastro)';
    default:
      return getInstrumentoLongDescription(campo);
  }
};

export const getCriShortDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante';
    case 'TipoGarantia':
      return 'Tipo de Garantia';
    case 'AtivoGarantia':
      return 'Ativo da Garantia';
    case 'NomeGarantidor':
      return 'Nome do Garantidor';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor';
    case 'ValorGarantia':
      return 'Valor da Garantia';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getCriLongDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado (Características da Emissão)';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM (Características da Emissão)';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório (Informações do Lastro)';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante (Informações do Lastro)';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante (Informações do Lastro)';
    case 'TipoGarantia':
      return 'Tipo de Garantia (Informações do Lastro)';
    case 'AtivoGarantia':
      return 'Ativo da Garantia (Informações do Lastro)';
    case 'NomeGarantidor':
      return 'Nome do Garantidor (Informações do Lastro)';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor (Informações do Lastro)';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor (Informações do Lastro)';
    case 'ValorGarantia':
      return 'Valor da Garantia (Informações do Lastro)';
    default:
      return getInstrumentoLongDescription(campo);
  }
};

export const getDebentureShortDescription = (campo: string) => {
  switch (campo) {
    case 'EscrituraEmissaoFormalizado':
      return 'Escritura de Emissão Formalizado';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getDebentureLongDescription = (campo: string) => {
  switch (campo) {
    case 'EscrituraEmissaoFormalizado':
      return 'Escritura de Emissão Formalizado (Características da Emissão)';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getNotaComercialShortDescription = (campo: string) => {
  switch (campo) {
    case 'CartulaEmissaoFormalizado':
      return 'Cártula de Emissão Formalizado';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getNotaComercialLongDescription = (campo: string) => {
  switch (campo) {
    case 'CartulaEmissaoFormalizado':
      return 'Cártula de Emissão Formalizado (Características da Emissão)';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getCertificadoRecebiveisShortDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante';
    case 'TipoGarantia':
      return 'Tipo de Garantia';
    case 'AtivoGarantia':
      return 'Ativo da Garantia';
    case 'NomeGarantidor':
      return 'Nome do Garantidor';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor';
    case 'ValorGarantia':
      return 'Valor da Garantia';
    default:
      return getInstrumentoShortDescription(campo);
  }
};

export const getCertificadoRecebiveisLongDescription = (campo: string) => {
  switch (campo) {
    case 'TermoSecuritizacaoFormalizado':
      return 'Termo de securitização formalizado (Características da Emissão)';
    case 'CodigoCvmCiaSecuritizadora':
      return 'Código securitizadora na CVM (Características da Emissão)';
    case 'AverbadoEmCartorio':
      return 'Averbado em cartório (Informações do Lastro)';
    case 'RegistroNaInstituicaoCustodiante':
      return 'Registro na Inst. Custodiante (Informações do Lastro)';
    case 'GarantiaFlutuante':
      return 'Garantia Flutuante (Informações do Lastro)';
    case 'TipoGarantia':
      return 'Tipo de Garantia (Informações do Lastro)';
    case 'AtivoGarantia':
      return 'Ativo da Garantia (Informações do Lastro)';
    case 'NomeGarantidor':
      return 'Nome do Garantidor (Informações do Lastro)';
    case 'CpfCnpjGarantidor':
      return 'CPF/CNPJ do Garantidor (Informações do Lastro)';
    case 'NaturezaGarantidor':
      return 'Natureza do Garantidor (Informações do Lastro)';
    case 'ValorGarantia':
      return 'Valor da Garantia (Informações do Lastro)';
    default:
      return getInstrumentoLongDescription(campo);
  }
};

export const getInstrumentoFinanceiroShortDescription: { [key: string]: string } = {
  [InstrumentoFinanceiro.Cra]: 'CRA',
  [InstrumentoFinanceiro.Cri]: 'CRI',
  [InstrumentoFinanceiro.Debenture]: 'DEB',
  [InstrumentoFinanceiro.NotaComercial]: 'NC',
  [InstrumentoFinanceiro.CertificadoRecebiveis]: 'CR',
  [InstrumentoFinanceiro.Cdca]: 'CDCA',
  [InstrumentoFinanceiro.CotasDeFundo]: 'CF',
};

export const getInstrumentoFinanceiroLongDescription: { [key: string]: string } = {
  [InstrumentoFinanceiro.Cra]: 'CRA',
  [InstrumentoFinanceiro.Cri]: 'CRI',
  [InstrumentoFinanceiro.Debenture]: 'Debênture',
  [InstrumentoFinanceiro.NotaComercial]: 'Nota Comercial',
  [InstrumentoFinanceiro.CertificadoRecebiveis]: 'Certificado de Recebíveis',
  [InstrumentoFinanceiro.Cdca]: 'CDCA',
  [InstrumentoFinanceiro.CotasDeFundo]: 'Cotas de Fundo',
};

export const getInstrumentoTipo = (instrumento: string) => {
  switch (instrumento) {
    case 'CRA':
      return InstrumentoFinanceiro.Cra;
    case 'CRI':
      return InstrumentoFinanceiro.Cri;
    case 'DEB':
      return InstrumentoFinanceiro.Debenture;
    case 'NC':
      return InstrumentoFinanceiro.NotaComercial;
    case 'CR':
      return InstrumentoFinanceiro.CertificadoRecebiveis;
    case 'CDCA':
      return InstrumentoFinanceiro.Cdca;
    case 'CF':
      return InstrumentoFinanceiro.CotasDeFundo;
    default:
      return InstrumentoFinanceiro.NotaComercial;
  }
}

export const tipoPagamentoDescriptions: { [key: string]: string } = {
  [TipoPagamento.PagamentoFinal]: 'Pagamento Final',
  [TipoPagamento.TabelaSac]: 'Tabela SAC',
  [TipoPagamento.TabelaPrice]: 'Tabela Price',
};

export const convencaoCalendarioPagamentoDescriptions: { [key: string]: string } = {
  [ConvencaoCalendarioPagamento.ProximoDiaUtil]: 'Próximo Dia Útil',
  [ConvencaoCalendarioPagamento.SemTratamento]: 'Sem Tratamento',
};

export const periodicidadeFluxoPagamentoDescriptions: { [key: string]: string } = {
  [PeriodicidadeFluxoPagamento.Quinzenal]: 'Quinzenal',
  [PeriodicidadeFluxoPagamento.Mensal]: 'Mensal',
  [PeriodicidadeFluxoPagamento.Trimestral]: 'Trimestral',
  [PeriodicidadeFluxoPagamento.Semestral]: 'Semestral',
  [PeriodicidadeFluxoPagamento.Anual]: 'Anual',
};

export const garantiaTipoDescriptions: { [key: string]: string } = {
  [GarantiaTipoEnum.SEM_GARANTIA]: 'Sem Garantia',
  [GarantiaTipoEnum.FIDEJUSSORIA]: 'Fidejussória',
  [GarantiaTipoEnum.GARANTIA_REAL]: 'Garantia Real',
};

export const garantiaSubTipoDescriptions: { [key: string]: string } = {
  [GarantiaSubTipoEnum.COM_COOBRIGACAO]: 'Com Coobrigação',
  [GarantiaSubTipoEnum.SEM_COOBRIGACAO]: 'Sem Coobrigação',
  [GarantiaSubTipoEnum.AVAL]: 'Aval',
  [GarantiaSubTipoEnum.FIANCA]: 'Fiança',
  [GarantiaSubTipoEnum.DIREITOS_CREDITORIOS]: 'Direitos Creditórios',
  [GarantiaSubTipoEnum.RECEBIVEIS_CARTAO_CREDITO]: 'Recebíveis Cartão Crédito',
  [GarantiaSubTipoEnum.TITULOS_CREDITO]: 'Título Crédito',
  [GarantiaSubTipoEnum.VEICULOS]: 'Veículos',
  [GarantiaSubTipoEnum.IMOVEL]: 'Imóvel',
  [GarantiaSubTipoEnum.SAFRA]: 'Safra',
  [GarantiaSubTipoEnum.ESTOQUE]: 'Estoque',
  [GarantiaSubTipoEnum.INVESTIMENTOS]: 'Investimento',
  [GarantiaSubTipoEnum.MAQUINARIO]: 'Maquinário',
  [GarantiaSubTipoEnum.EMBARCACAO]: 'Embarcação',
  [GarantiaSubTipoEnum.AERONAVE]: 'Aeronave',
  [GarantiaSubTipoEnum.OUTROS]: 'Outros',
};

export const tipoCertidaoDescriptions: { [key: string]: string } = {
  [TipoCertidao.CertidaoTitularidade]: "Certidão de Titularidade",
  [TipoCertidao.TermoEncerramento]: "Termo de Encerramento de Instrumento Financeiro",
  [TipoCertidao.ExtratoMovimentacoes]: "Extrato de Movimentações",
  [TipoCertidao.Gravame]: "Certidão de Bloqueios e Gravames",
  [TipoCertidao.CertidaoInadimplencia]: "Certidão de Inadimplência"
};

export const tipoDocumentoS3Descriptions: { [key: string]: string } = {
  [TipoDocumentoS3.RegistrodeNC]: 'Registro de NC',
  [TipoDocumentoS3.LancamentoOP]: 'Lançamento OP',
  [TipoDocumentoS3.CadastroLote]: 'Cadastro Investidor PJ/PF',
  [TipoDocumentoS3.CadastroFundosLote]: 'Cadastro Investidor Fundo',
};

export const multaMoraLabels = {
  percentualMulta: 'Percentual de Juros de Multa (%)',
  periodicidadeMulta: 'Periodicidade dos Juros de Multa',
  percentualMora: 'Percentual de Juros de Mora (%)',
  periodicidadeMora: 'Periodicidade dos Juros de Mora'
};
